export const screenshot = (
  canvas: HTMLCanvasElement,
  x: number,
  y: number,
  width: number,
  height: number,
) => {
  const snapshot = document.createElement('canvas');

  snapshot.width = width;
  snapshot.height = height;

  const context = snapshot.getContext('2d')!;

  context.drawImage(canvas, x, y, width, height, 0, 0, width, height);

  return snapshot;
};
